import { ActionLink } from "@wine2trace/ui/FormComponents";
import useLabels from "../../hooks/useLabels";
import LegalTitle from "./LegalTitle";

const asArray = (value) => (Array.isArray(value) ? value : []);

// A block of a section: `v` is a text or a list of paragraphs, where a nested array is a bulleted list.
// `to` (optional) is a page of the app the text refers to, shown as a link after the text.
const Block = ({ block }) => {
  const { title, v, to } = block;
  const paragraphs = typeof v === "string" ? [v] : asArray(v);

  return (
    <div className="legal_block">
      {title ? <h3 className="legal_block_title">{title}</h3> : null}
      {paragraphs.map((paragraph, i) =>
        Array.isArray(paragraph) ? (
          <ul key={`list-${i}`} className="legal_list">
            {paragraph.map((item, j) => (
              <li key={`item-${i}-${j}`}>{item}</li>
            ))}
          </ul>
        ) : (
          <p key={`par-${i}`}>{paragraph}</p>
        ),
      )}
      {to ? (
        <p>
          <ActionLink to={to} variant="inline">
            {title || to}
          </ActionLink>
        </p>
      ) : null}
    </div>
  );
};

// Public pages /privacy and /cookie (inside LegalLayout, which links the sibling pages in its footer): the legal text from the labels (privacy_* or cookie*), one section per item.
// Derived on every render, so labels that load late or change with the language show up.
// Styles: styles/shared/_legal_page.scss.
const AdditionalInfo = ({ type }) => {
  const [getLabel] = useLabels();
  const isCookie = type === "cookie";
  const intro = isCookie ? [] : asArray(getLabel("privacy_header"));
  const sections = asArray(getLabel(isCookie ? "cookie" : "privacy_items"));

  return (
    <div className="legal_page">
      <article className="legal_card" aria-labelledby="legal-title">
        <LegalTitle
          id="legal-title"
          title={isCookie ? getLabel("cookie_title") : getLabel("privacy_title")}
          lead={isCookie ? null : getLabel("privacy_subtitle", { name: "Wine2Trace" })}
        />
        {intro.length > 0 && (
          <div className="legal_intro">
            {intro.map((text, i) => (
              <p key={`intro-${i}`}>{text}</p>
            ))}
          </div>
        )}
        {sections.map((section, i) => (
          <section key={`section-${i}`} className="legal_section" aria-labelledby={`legal-section-${i}`}>
            <h2 id={`legal-section-${i}`} className="legal_section_title">
              {section?.title}
            </h2>
            {asArray(section?.p).map((block, j) => (
              <Block key={`block-${i}-${j}`} block={block} />
            ))}
          </section>
        ))}
      </article>
    </div>
  );
};

export default AdditionalInfo;
